import { Spinner } from "react-bootstrap";
function LoadingIndicator() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)", // Semi-opaque background
      }}
    >
      <Spinner animation="border" variant="primary" />
    </div>
  );
}

export default LoadingIndicator;
